import { CACHE_KEYS } from "@repo/api-services/CacheKeys";
import { handleGlobalGetRequestQuery } from "@repo/api-services/getRequestsGlobal.ts";
import URLS from "@repo/api-services/URLS";
import { useQuery } from "@tanstack/react-query";
import {
  IExecutiveDashboardResponse,
  IInsurerProduct,
} from "./executiveSignals.types";

interface UseExecutiveSignalsProps {
  filters?: Record<string, string>;
}

const useGetAllExecutiveSignals = ({ filters }: UseExecutiveSignalsProps) => {
  const getAllExecutivesignals = useQuery<IExecutiveDashboardResponse>({
    queryKey: [...CACHE_KEYS.EXECUTIVE_SIGNALS, filters],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.EXECUTIVE_SIGNALS,
        searchParams: {
          ...filters,
        },
      }),
  });

  return {
    services: {
      getAllExecutivesignals,
    },
  };
};

interface IUseGetExecutiveSignalsProductsProps {
  insurer_id: string | null;
}

const useGetExecutiveSignalsProducts = ({
  insurer_id,
}: IUseGetExecutiveSignalsProductsProps) => {
  const executiveSignalsProducts = useQuery<IInsurerProduct>({
    queryKey: [...CACHE_KEYS.EXECUTIVE_SIGNALS_PRODUCTS, insurer_id],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `${URLS.EXECUTIVE_SIGNALS}/${insurer_id}/products`,
      }),
    enabled: !!insurer_id,
  });

  return { services: { executiveSignalsProducts } };
};

export { useGetAllExecutiveSignals, useGetExecutiveSignalsProducts };
